import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import TopBar from "./TopBar";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFab from "./WhatsAppFab";
import BackToTop from "./BackToTop";
import CookieBanner from "./CookieBanner";
import NewsletterPopup from "./NewsletterPopup";
import MaintenanceOverlay from "./MaintenanceOverlay";
import { useSettingsStore } from "../../store/settingsStore";
import { Toaster } from "sonner";

export default function PublicLayout() {
    const { fetchSettings, loaded } = useSettingsStore();
    useEffect(() => {
        if (!loaded) fetchSettings();
    }, [loaded, fetchSettings]);

    return (
        <div className="App min-h-screen flex flex-col">
            <TopBar />
            <Header />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <WhatsAppFab />
            <BackToTop />
            <CookieBanner />
            <NewsletterPopup />
            <MaintenanceOverlay />
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}
